import { useTypedSelector } from "hooks";
import { selectCountries, selectIsCountriesLoading } from "./selectors";
import useFetchFeatureResource from "hooks/useFetchFeatureResource";
import { getCountries as getCountriesRequest } from "./api";
import { changeCountriesLoadingState, changeCountriesSlice } from "./slice";
import useSessionEffect from "hooks/useSessionEffect";
import { PER_PAGE_SIZE } from "consts/transactions";
import { FetchResourceSettings } from "hooks/useFetchResource";

const countriesSessionEffectSymbol = Symbol('countriesSessionEffect');

type UseCountriesArg = FetchResourceSettings & {
    readonly resourceRequest?: (query?: string) => Promise<Response>;
};

export default function useCountries({
    resourceRequest = getCountriesRequest,
    shouldFetchAll = true,
    perPage = PER_PAGE_SIZE
}: UseCountriesArg = {}) {
    const countries = useTypedSelector(selectCountries);
    const isCountriesLoading = useTypedSelector(selectIsCountriesLoading);

    const getCountries = useFetchFeatureResource({
        shouldFetchAll,
        perPage,
        resourceRequest,
        changeLoadingState: changeCountriesLoadingState,
        changeSlice: changeCountriesSlice
    });

    useSessionEffect(() => {
        getCountries();
    }, countriesSessionEffectSymbol);

    return {
        countries,
        isCountriesLoading
    };
};
